import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UnitMaster {
  size: string
  quantity: number
  occupied: number
  isClimate: boolean
  isCovered: boolean
  description: string
  price: number
  isAvailable?: boolean
  available?: number
  unitNumber?: string
  customerProfileId?: number | string
  subscriptionId?: number | string
  id?: string
  masterId?: string
}

export interface UnitIndividual {
  size: string
  isClimate: boolean
  isCovered: boolean
  unitNumber?: string
  customerProfileId?: number | string
  subscriptionId?: number | string
  id?: string
  masterId?: string
}

export interface UnitCancel {
  id?: string
  subscriptionId: string
  customerProfileId: number
  phoneNumber: string
  fullName: string
  email: string
  lastPayment?: string
  moveOut?: string
  paymentStatus?: 'pending' | 'paid' | 'failed' | 'unpaid'
  isCanceled?: boolean
  unitId?: string
  masterId?: string
  unitNumber?: string
  size?: string
  cancelRequestDate?: string
  cancelEffectiveDate?: string
  subscriptionCancelled?: boolean
  requestEmailSent?: boolean
}

export interface UnitMasterResponse {
  key: string
  value: UnitMaster
}

export interface IUnitsState {
  unitsMaster: UnitMaster[]
  unitsIndividual: UnitMaster[]
  unitsCancel: UnitCancel[]
}

const initialState: IUnitsState = {
  unitsMaster: [],
  unitsIndividual: [],
  unitsCancel: [],
}

export const slice = createSlice({
  name: 'units',
  initialState,
  reducers: {
    onUnitsMaster: (
      state: IUnitsState,
      action: PayloadAction<typeof initialState.unitsMaster>
    ) => {
      state.unitsMaster = action.payload
    },
    onUnitsIndividual: (
      state: IUnitsState,
      action: PayloadAction<typeof initialState.unitsIndividual>
    ) => {
      state.unitsIndividual = action.payload
    },
    onUnitsCancel: (
      state: IUnitsState,
      action: PayloadAction<typeof initialState.unitsCancel>
    ) => {
      state.unitsCancel = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type IUnits = {
  units: IUnitsState
}
